import {Globals} from "../../global/globals.js";

export class Banners {
    static URLS = [
        "assets/banners/EXR_Logo_Mark_White.png",
        "assets/banners/EXR_Logo_Stacked_White.png",
        "assets/banners/moonbeam_logo_full.png",
        "assets/banners/moonbeam_logo_icon.png",
        "assets/banners/polkadot_logo_full.png",
        "assets/banners/polkadot_logo_icon.png",
        "assets/banners/zeitgeist_logo_short.png",
        "assets/banners/zeitgeist_logo_icon_white.png"
    ]

    static requests = [];

    /**
     * Request a banner URL
     * @returns {string} A banner URL
     */
    static requestURL() {
        return Banners.URLS[Math.floor(Math.random() * Banners.URLS.length)];
    }

    /**
     * Request a banner
     * @param {number} aspect The aspect ratio
     * @returns {Promise<THREE.Texture>} A promise that returns a texture
     */
    static requestBanner(aspect = 1) {
        return Globals.TEXTURE_CACHE.load(Banners.requestURL());
    }
}